
interface Jobs {
  [key: string]: {
    jobScreen: string
    meta?: { [key: string]: string }
  };
}
interface JobScreens {
  [key: string]: {
    latestRequestId: string;
    refresh: boolean
    eventMeta?: any
  };
}

interface InitialState {
  jobs: Jobs;
  jobScreens: JobScreens;
}

const initial_state: InitialState = {
  jobs: {},
  jobScreens: {}
};
export function realtimeJob
    (state = initial_state, action: any) {
    const payload = action.data
    switch (action.type) {
        case 'INITIATE_BACKGROUND_JOB':
          if (!payload.requestId) { 
            return {...state }
          } else {
            state.jobs[payload.requestId] = { jobScreen: payload.jobScreen, meta: payload.meta }
            state.jobScreens[payload.jobScreen] = { latestRequestId: payload.requestId, refresh: false }
            return {
              ...state
            };
          }
        case 'REFRESH_SCREEN':
          const refreshJob = state.jobs[payload.requestId]
          if(refreshJob){
            state.jobScreens[refreshJob.jobScreen].refresh = true
            state.jobScreens[refreshJob.jobScreen].eventMeta = payload.eventMeta
          }
          return { 
            ...state
          }            
        case 'COMPLETE_BACKGROUND_JOB':
          const job = state.jobs[payload.requestId]
          if(job){
            delete state.jobScreens[job.jobScreen]
            delete state.jobs[payload.requestId]
          }
          return { 
            ...state
          }  
        default:
            return state;
    }
}
